import { motion } from "framer-motion";
import { MailCheck } from "lucide-react";
import { fadeInUp, transition } from "@/utils/motion";

const VerificationSentView = ({ email, resending, onResend, onBack }) => (
  <div className="max-w-md mx-auto px-6 py-16" data-testid="verification-sent-page">
    <motion.div {...fadeInUp} transition={transition} className="hud-card clip-corners p-8 text-center">
      <MailCheck className="h-12 w-12 text-[#FFE800] mx-auto mb-4" />
      <h1 className="font-headings text-2xl uppercase tracking-widest text-[#FFE800] mb-2" data-testid="verification-sent-title">
        Check Your Email
      </h1>
      <p className="text-sm text-gray-400 mb-2">We sent a verification link to:</p>
      <p className="font-data text-[#FFE800] text-sm mb-6" data-testid="verification-sent-email">{email}</p>
      <p className="text-xs text-gray-500 mb-6">Click the link in the email to activate your account. The link expires in 24 hours.</p>
      <button
        onClick={() => onResend(email)}
        disabled={resending}
        className="border border-white/20 px-6 py-2 text-xs font-data text-gray-400 hover:text-[#FFE800] hover:border-[#FFE800] disabled:opacity-40"
        data-testid="resend-verification-button"
      >
        {resending ? "Sending..." : "Resend Verification Email"}
      </button>
      <button onClick={onBack} className="block mx-auto mt-4 text-xs text-gray-500 hover:text-white" data-testid="back-to-login-button">
        Back to sign in
      </button>
    </motion.div>
  </div>
);

export default VerificationSentView;
